package cc.easyandroid.easycompose.component.instancekeeper

import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeperDispatcher
import cc.easyandroid.easycompose.core.lifecycle.Lifecycle
import cc.easyandroid.easycompose.core.lifecycle.doOnDestroy

internal fun InstanceKeeperDispatcher.attachTo(lifecycle: Lifecycle): InstanceKeeperDispatcher {
    lifecycle.doOnDestroy(::destroy)

    return this
}
